import {Component, OnInit} from '@angular/core';

import {ICsGridAction} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.interface';
import {
    ICsGridActionCellRenderer
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-cell-renderers.interface';

@Component({
    selector: 'app-cs-ag-grid-select-renderer',
    templateUrl: './cs-ag-grid-select-renderer.component.html',
    styleUrls: ['../../../../features/v5-common-styles/utils.scss']
})
export class CsAgGridSelectRendererComponent implements OnInit {

    selectedItem: any;
    selectList: any;
    params: any;
    showValueOnly: boolean;
    constructor() {
    }

    ngOnInit() {
        this.selectedItem = this.params.selectedItem(this.params);
        this.selectList = this.params.selectList(this.params);
        this.showValueOnly = this.params.showValueOnly(this.params);
    }

    onClickAction(value: any) {
        let data: any = [
            {
                'stageId': value,
                'defectId': this.params.data.id
            }
        ];
        this.params.clickAction(data);
    }
}
